module.exports = __webpack_public_path__ + "img/Recurso 11.432b99f1.png";